import React from 'react';
interface LogoProps {
  className?: string;
  width?: number | string;
}
const GoldDefs = () => <defs data-id="element-247">
    <linearGradient id="goldGradient" x1="0" y1="0" x2="0" y2="1" data-id="element-248">
      <stop offset="0%" stopColor="#D4B56F" data-id="element-249" />
      <stop offset="100%" stopColor="#B8924A" data-id="element-250" />
    </linearGradient>
    <filter id="goldShadow" x="-10%" y="-10%" width="120%" height="120%" data-id="element-251">
      <feDropShadow dx="0" dy="1" stdDeviation="2" floodColor="#B8924A" floodOpacity="0.15" data-id="element-252" />
    </filter>
  </defs>;
const CrownPaths = () => <g stroke="url(#goldGradient)" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-253">
    {/* Base bands */}
    <path d="M 110 40 L 170 40" data-id="element-254" />
    <path d="M 112 44 L 168 44" data-id="element-255" />
    {/* Dots in band */}
    <circle cx="120" cy="42" r="0.5" fill="url(#goldGradient)" stroke="none" data-id="element-256" />
    <circle cx="130" cy="42" r="0.5" fill="url(#goldGradient)" stroke="none" data-id="element-257" />
    <circle cx="140" cy="42" r="0.5" fill="url(#goldGradient)" stroke="none" data-id="element-258" />
    <circle cx="150" cy="42" r="0.5" fill="url(#goldGradient)" stroke="none" data-id="element-259" />
    <circle cx="160" cy="42" r="0.5" fill="url(#goldGradient)" stroke="none" data-id="element-260" />
    {/* Spikes */}
    <path d="M 110 40 L 100 22 L 120 32 L 140 8 L 160 32 L 180 22 L 170 40" data-id="element-261" />
    {/* Jewels */}
    <circle cx="100" cy="22" r="1.5" fill="url(#goldGradient)" stroke="none" data-id="element-262" />
    <circle cx="120" cy="32" r="1.5" fill="url(#goldGradient)" stroke="none" data-id="element-263" />
    <circle cx="140" cy="8" r="2" fill="url(#goldGradient)" stroke="none" data-id="element-264" />
    <circle cx="160" cy="32" r="1.5" fill="url(#goldGradient)" stroke="none" data-id="element-265" />
    <circle cx="180" cy="22" r="1.5" fill="url(#goldGradient)" stroke="none" data-id="element-266" />
  </g>;
const LaurelPaths = () => <g stroke="url(#goldGradient)" strokeWidth="1.25" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-267">
    {/* Left Branch Stem */}
    <path d="M 135 190 C 70 185 50 90 125 55" data-id="element-268" />
    {/* Right Branch Stem */}
    <path d="M 145 190 C 210 185 230 90 155 55" data-id="element-269" />

    {/* Left Leaves */}
    <path d="M 125 185 C 110 180 105 170 115 165 C 125 170 125 180 125 185 Z" data-id="element-270" />
    <path d="M 105 165 C 90 160 85 150 95 145 C 105 150 105 160 105 165 Z" data-id="element-271" />
    <path d="M 85 140 C 70 135 65 125 75 120 C 85 125 85 135 85 140 Z" data-id="element-272" />
    <path d="M 72 110 C 57 105 52 95 62 90 C 72 95 72 105 72 110 Z" data-id="element-273" />
    <path d="M 75 80 C 65 70 65 60 75 55 C 85 65 85 75 75 80 Z" data-id="element-274" />
    <path d="M 95 60 C 90 50 95 40 105 35 C 110 45 105 55 95 60 Z" data-id="element-275" />

    {/* Right Leaves */}
    <path d="M 155 185 C 170 180 175 170 165 165 C 155 170 155 180 155 185 Z" data-id="element-276" />
    <path d="M 175 165 C 190 160 195 150 185 145 C 175 150 175 160 175 165 Z" data-id="element-277" />
    <path d="M 195 140 C 210 135 215 125 205 120 C 195 125 195 135 195 140 Z" data-id="element-278" />
    <path d="M 208 110 C 223 105 228 95 218 90 C 208 95 208 105 208 110 Z" data-id="element-279" />
    <path d="M 205 80 C 215 70 215 60 205 55 C 195 65 195 75 205 80 Z" data-id="element-280" />
    <path d="M 185 60 C 190 50 185 40 175 35 C 170 45 175 55 185 60 Z" data-id="element-281" />

    {/* Centerline veins (subtle) */}
    <g strokeWidth="0.5" opacity="0.7" data-id="element-282">
      <path d="M 125 185 L 115 165" data-id="element-283" />
      <path d="M 105 165 L 95 145" data-id="element-284" />
      <path d="M 85 140 L 75 120" data-id="element-285" />
      <path d="M 72 110 L 62 90" data-id="element-286" />
      <path d="M 75 80 L 75 55" data-id="element-287" />
      <path d="M 95 60 L 105 35" data-id="element-288" />

      <path d="M 155 185 L 165 165" data-id="element-289" />
      <path d="M 175 165 L 185 145" data-id="element-290" />
      <path d="M 195 140 L 205 120" data-id="element-291" />
      <path d="M 208 110 L 218 90" data-id="element-292" />
      <path d="M 205 80 L 205 55" data-id="element-293" />
      <path d="M 185 60 L 175 35" data-id="element-294" />
    </g>
  </g>;
const SilhouettePaths = () => <g stroke="url(#goldGradient)" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-295">
    {/* Face Profile (looking left) */}
    <path d="M 135 65 C 130 65 128 70 128 75 C 128 78 132 80 132 82 C 132 84 129 86 129 88 C 129 92 135 95 135 98" data-id="element-296" />

    {/* Flowing Hair Left */}
    <path d="M 135 55 C 110 55 100 80 105 110 C 110 140 90 160 95 185" data-id="element-297" />
    <path d="M 140 58 C 120 60 110 90 115 120 C 120 150 100 170 105 190" data-id="element-298" />

    {/* Flowing Hair Right */}
    <path d="M 145 55 C 170 60 165 90 175 120 C 185 150 160 170 170 190" data-id="element-299" />
    <path d="M 140 60 C 160 65 155 95 165 125 C 175 155 150 175 160 195" data-id="element-300" />

    {/* Neck and Shoulders */}
    <path d="M 135 98 C 135 105 130 110 120 115" data-id="element-301" />
    <path d="M 145 95 C 145 105 150 110 160 115" data-id="element-302" />

    {/* Bustier / Corset Top */}
    <path d="M 120 115 C 130 125 140 125 150 120 C 160 115 160 115 160 115" data-id="element-303" />

    {/* Hourglass Body Curves */}
    <path d="M 115 125 C 125 145 125 160 110 185" data-id="element-304" />
    <path d="M 155 125 C 145 145 145 160 160 185" data-id="element-305" />

    {/* Corset details */}
    <path d="M 135 125 L 135 175" strokeWidth="1" opacity="0.6" data-id="element-306" />
    <path d="M 125 130 L 125 170" strokeWidth="1" opacity="0.6" data-id="element-307" />
    <path d="M 145 130 L 145 170" strokeWidth="1" opacity="0.6" data-id="element-308" />
  </g>;
export const Logo: React.FC<LogoProps> = ({
  className = '',
  width = 240
}) => {
  return <svg viewBox="0 0 280 340" width={width} className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-309">
      <GoldDefs data-id="element-310" />

      <CrownPaths data-id="element-311" />
      <LaurelPaths data-id="element-312" />
      <SilhouettePaths data-id="element-313" />

      {/* Typography */}
      <text x="140" y="245" fontFamily="'Cormorant Garamond', 'Cinzel', serif" fontSize="34" fontWeight="400" textAnchor="middle" fill="url(#goldGradient)" letterSpacing="0.1em" filter="url(#goldShadow)" data-id="element-314">
        SCULPTED BODY
      </text>

      <text x="140" y="280" fontFamily="'Cormorant Garamond', 'Cinzel', serif" fontSize="14" fontWeight="400" textAnchor="middle" fill="#FAF7F2" letterSpacing="0.15em" filter="url(#goldShadow)" data-id="element-315">
        · FAJAS COLOMBIANAS ·
      </text>

      <text x="140" y="310" fontFamily="'Cormorant Garamond', 'Cinzel', serif" fontSize="11" fontWeight="400" textAnchor="middle" fill="#FAF7F2" letterSpacing="0.2em" filter="url(#goldShadow)" data-id="element-316">
        PREMIUM SHAPEWEAR &amp; CURVES
      </text>

      {/* Bottom Chevron */}
      <path d="M 115 330 L 140 340 L 165 330" stroke="url(#goldGradient)" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-317" />
    </svg>;
};
export const LogoMark: React.FC<{
  className?: string;
}> = ({
  className = 'w-12 h-12'
}) => {
  return <svg viewBox="40 0 200 200" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-318">
      <GoldDefs data-id="element-319" />
      <CrownPaths data-id="element-320" />
      <LaurelPaths data-id="element-321" />
      <SilhouettePaths data-id="element-322" />
    </svg>;
};
export const LogoCrown: React.FC<{
  className?: string;
}> = ({
  className = 'w-8 h-8'
}) => {
  return <svg viewBox="90 0 100 50" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-323">
      <GoldDefs data-id="element-324" />
      <CrownPaths data-id="element-325" />
    </svg>;
};